import { render, staticRenderFns } from "./VMenu.vue?vue&type=template&id=fa6fa51c&"
import script from "./VMenu.vue?vue&type=script&lang=js&"
export * from "./VMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports